import styled from 'styled-components'

export const Container = styled.nav`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  margin-bottom: 0.5rem;
  gap: 0.5rem;
`
